define('charts/layers/flares',["require", "exports", "../../baseline/flare", "../../util/convert"], function (require, exports, flare_1, convert_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Flares = void 0;
    var Flares = /** @class */ (function () {
        function Flares(track) {
            this.track = track;
            this.flares = (0, flare_1.findFlares)(track);
        }
        Flares.prototype.init = function (chart) {
            // Add layer for flares
            this.svgGroup = chart.layers.space.append("g")
                .attr("class", "flares")
                .style("clip-path", "url(#chart-clipping-time)");
            var flares = this.svgGroup.selectAll("rect")
                .data(this.flares);
            flares.enter()
                .append("rect")
                .attr("y", chart.height())
                .attr("height", chart.margin.bottom);
            var flareHeights = this.svgGroup.selectAll("text")
                .data(this.flares);
            flareHeights.enter()
                .append("text")
                .attr("y", chart.height() - 2);
        };
        Flares.prototype.update = function (chart) {
            var _this = this;
            var tz = function (d) { return _this.track.utcToBrowser(d); };
            var scaleX = function (millis) { return Math.floor(chart.xAxis.scale(tz(millis))); };
            this.svgGroup.selectAll("rect")
                .attr("x", function (d) { return scaleX(d.bottom.millis); })
                .attr("width", function (d) { return scaleX(d.top.millis) - scaleX(d.bottom.millis); })
                .style("fill", "#6b00ff")
                .style("opacity", 0.5);
            this.svgGroup.selectAll("text")
                .attr("x", function (d) { return scaleX(d.bottom.millis); })
                .style("fill", "#6b00ff")
                .text(function (d) { return "+" + convert_1.default.distance.localString(d.top.alt - d.bottom.alt); });
        };
        Flares.prototype.remove = function () {
            this.svgGroup.remove();
        };
        return Flares;
    }());
    exports.Flares = Flares;
});
//# sourceMappingURL=/assets/javascripts/charts/layers/flares.js.map;
